




































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import FormProvider from '@shared/components/forms/form-provider.vue';
import Input from '@shared/components/forms/inputs/input/input.vue';
import DisplayFieldBadge from '@shared/components/displays/display-field-badge/display-field-badge.vue';
import { PosSessionSyncInterface } from '@modules/accounting-integrations/interfaces/pos-session-sync';
import {
  errorsTableFields,
  paymentsByTypeTableFields,
  posSessionSyncDisplayFields,
  posSessionSyncFieldConfig,
  posSessionSyncTableFields,
  salesByAccountTableFields,
  salesByArticleTableFields,
} from '@modules/accounting-integrations/config/pos_session_sync_options';
import BcTable from '@shared/components/tables/table.vue';

@Component({
  name: 'sale-day-sync-details',
  components: {
    'bpc-form-provider': FormProvider,
    'bc-input': Input,
    'bc-display-field-badge': DisplayFieldBadge,
    BcTable,
  },
})
export default class PosSessionSyncDetails extends Vue {
  @Prop({ required: true }) readonly sessionId!: number | string;
  @Prop({ type: String, required: true })
  readonly saleDayType: 'pos' | 'online';

  formModel: PosSessionSyncInterface = {
    id: 0,
    date: '',
    journalCode: '',
    journalName: '',
    totalSales: 0,
    totalPayments: 0,
    totalMovements: 0,
    totalErrors: 0,
    validationStatus: 'opened',
    syncStatus: null,
    posSessions: [],
    salesByArticle: [],
    canBeSynced: false,
  };

  readonly posSessionSyncTableFields = posSessionSyncTableFields;
  readonly salesByArticleTableFields = salesByArticleTableFields;
  readonly salesByAccountTableFields = salesByAccountTableFields;
  readonly paymentsByTypeTableFields = paymentsByTypeTableFields;
  readonly errorsTableFields = errorsTableFields;

  readonly balanceStatusConfig = {
    displayType: 'badge',
    valueToLabel: [
      { value: true, label: 'Correct' },
      { value: false, label: 'Incorrect' },
    ],
    valueToVariant: [
      { value: true, variant: 'success' },
      { value: false, variant: 'danger' },
    ],
  };

  readonly errorTypeConfig = {
    displayType: 'badge',
    valueToLabel: [
      {
        value: true,
        label: this.$t('accounting_integrations.sale_day_sync.details.tabs.pos_errors.positive'),
      },
      {
        value: false,
        label: this.$t('accounting_integrations.sale_day_sync.details.tabs.pos_errors.negative'),
      },
    ],
    valueToVariant: [
      { value: true, variant: 'success' },
      { value: false, variant: 'danger' },
    ],
  };

  get displayConfig() {
    return posSessionSyncDisplayFields;
  }

  get fieldsConfig() {
    return posSessionSyncFieldConfig;
  }

  get journalName(): string {
    return `${this.formModel.journalCode} - ${this.formModel.journalName}`;
  }

  formatAmount(value: number): string {
    return new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: 'EUR',
    }).format(value || 0);
  }

  formatTimeRange(startTime: string, endTime: string): string {
    return `${startTime} - ${endTime}`;
  }

  get paymentsByTypeItems(): any[] {
    if (!this.formModel.paymentsByType) {
      return [];
    }
    return Object.values(this.formModel.paymentsByType);
  }

  async loadSessionData(id: number | string): Promise<void> {
    try {
      const numericId = parseInt(String(id).replace(/\D/g, ''), 10);
      if (isNaN(numericId)) {
        throw new Error('Invalid session ID');
      }

      const basePath = this.$bpcApiRouteHelper.getApiPath(
        `sales-synchronization/${this.saleDayType}`,
        'raw',
      );
      const response = await this.$bpcApi.get(`${basePath}/${numericId}`).toPromise();

      if (response.data) {
        const data = response.data.data || response.data;
        this.formModel = {
          ...this.formModel,
          ...data,
          posSessions: data.posSessions || [],
          salesByArticle: data.salesByArticle || [],
          salesByAccount: data.salesByAccount || [],
          paymentsByType: data.paymentsByType || {},
          cashErrors: data.cashErrors || [],
        };
      }
    } catch (error) {
      console.error('Error loading session:', error);
      const errorMessage = error instanceof Error ? error.message : 'An error occurred';
      this.$bpcMessage.showErrorMessage({ text: errorMessage });
    }
  }

  @Watch('sessionId', { immediate: true })
  onSessionIdChange(newId: number | string): void {
    if (newId) {
      this.loadSessionData(newId);
    }
  }
}
